<template>
  <main>
    <div>
      <md-radio v-model="_selectMode" value="category">
        分類
      </md-radio>
      <md-radio v-model="_selectMode" value="itemCategory">
        商品(分類指定)
      </md-radio>
      <md-radio v-model="_selectMode" value="item">
        商品(商品指定)
      </md-radio>
    </div>
    <filter-category
      v-if="isCategoryMode"
      :company="company"
      v-bind.sync="category"
      :pos-restriction="posRestriction"
      :enable-filter-new-items="enableFilterNewItems"
    />
    <filter-item-category
      v-if="isItemCategoryMode"
      :company="company"
      v-bind.sync="item"
      :pos-restriction="posRestriction"
      :enable-filter-new-items="enableFilterNewItems"
    />
    <component
      :is="filterItem"
      v-if="isItemMode"
      :company="company"
      v-bind.sync="item"
      :pos-restriction="posRestriction"
    />
  </main>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'
import FilterCategory from '@/components/FilterCategory.vue'
import FilterItem from '@/components/FilterItem.vue'
import FilterItem2 from '@/components/FilterItem2.vue'
import FilterItemCategory from '@/components/FilterItemCategory.vue'

export default {
  components: { FilterCategory, FilterItem, FilterItemCategory },
  mixins: [ErrorReport],

  props: {
    selectMode: {
      type: String,
      default: 'category',
    },
    company: {
      type: String,
    },
    category: {
      itemCategoryLevel: {
        type: Number,
      },
      categories: {
        type: Array,
        default: () => [],
      },
    },
    item: {
      itemGroupId: {
        type: String,
      },
      items: {
        type: Array,
        default: () => [],
      },
      categories: {
        type: Array,
        default: () => [],
      },
    },
    /**
     * POSの開示制限あり
     */
    posRestriction: {
      type: Boolean,
      default: false,
    },
    useNewItemComponent: {
      type: Boolean,
      default: false,
    },
    /**
     * 新商品のみに絞り込むかどうかのユーザー選択を有効にするか否か
     *
     * 絞り込みはあくまで分析結果であって、このフラグをOnにしてもツリー表示や
     * 商品検索には影響ありません。
     */
    enableFilterNewItems: {
      type: Boolean,
      default: false,
    },
    /**
     * 分類指定、商品選択での新商品絞り込み
     */
    filterNewItems: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    selectMode(value) {
      this.$emit('update:selectMode', value)
    },
  },
  computed: {
    filterItem() {
      return this.useNewItemComponent ? FilterItem2 : FilterItem
    },
    _selectMode: {
      get() {
        return this.selectMode
      },
      set(newVal) {
        this.$emit('update:selectMode', newVal)
      },
    },
    isCategoryMode() {
      return this.selectMode === 'category'
    },
    isItemCategoryMode() {
      return this.selectMode === 'itemCategory'
    },
    isItemMode() {
      return this.selectMode === 'item'
    },
    errors() {
      const errors = []

      if (this.selectMode === 'category') {
        for (let error of this.category.errors) {
          errors.push(error)
        }
      } else {
        for (let error of this.item.errors) {
          errors.push(error)
        }
      }
      return errors
    },
  },
}
</script>
